var _excluded = ["className", "height", "fixedLeft", "fixedRight", "nonFixed", "coverLeft", "coverRight", "style"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { classnames } from '@okee-uikit/react-utils';
import { usePrefixCls, useDirection } from '@okee-uikit/react-config';
import { useColumnSize } from '../../hooks/table';
import { TableFixedColumn } from './TableFixedColumn';
import { TableScrollerColumn } from './TableScrollerColumn';
export function TableColumnRender(props) {
  var className = props.className,
      height = props.height,
      propFixedLeft = props.fixedLeft,
      propFixedRight = props.fixedRight,
      nonFixed = props.nonFixed,
      propCoverLeft = props.coverLeft,
      propCoverRight = props.coverRight,
      _props$style = props.style,
      style = _props$style === void 0 ? {} : _props$style,
      extra = _objectWithoutProperties(props, _excluded);

  var rtl = useDirection() === 'rtl';

  var _useColumnSize = useColumnSize(),
      tableWidth = _useColumnSize.tableWidth,
      scrollerWidth = _useColumnSize.scrollerWidth,
      rawFixedLeftWidth = _useColumnSize.fixedLeftWidth,
      rawFixedRightWidth = _useColumnSize.fixedRightWidth,
      rawIgnoreFixedRight = _useColumnSize.ignoreFixedRight,
      rawIgnoreFixedLeft = _useColumnSize.ignoreFixedLeft;

  var _ref = rtl && [propFixedRight, propFixedLeft, rawFixedRightWidth, rawFixedLeftWidth, rawIgnoreFixedRight, rawIgnoreFixedLeft, propCoverRight, propCoverLeft] || [propFixedLeft, propFixedRight, rawFixedLeftWidth, rawFixedRightWidth, rawIgnoreFixedLeft, rawIgnoreFixedRight, propCoverLeft, propCoverRight],
      _ref2 = _slicedToArray(_ref, 8),
      fixedLeft = _ref2[0],
      fixedRight = _ref2[1],
      fixedLeftWidth = _ref2[2],
      fixedRightWidth = _ref2[3],
      ignoreFixedLeft = _ref2[4],
      ignoreFixedRight = _ref2[5],
      leftCover = _ref2[6],
      rightCover = _ref2[7];

  var cls = classnames(usePrefixCls('table-column'), className);
  return React.createElement("div", _objectSpread(_objectSpread({}, extra), {}, {
    className: cls,
    style: _objectSpread(_objectSpread({}, style), {}, {
      height: "".concat(height, "px"),
      width: "".concat(tableWidth, "px")
    })
  }), fixedLeft && !ignoreFixedLeft && React.createElement(TableFixedColumn, {
    height: height,
    position: "left",
    cover: leftCover,
    width: fixedLeftWidth
  }, fixedLeft), React.createElement(TableScrollerColumn, {
    height: height,
    width: tableWidth,
    scrollerWidth: scrollerWidth,
    fixedLeftWidth: fixedLeftWidth,
    fixedRightWidth: fixedRightWidth
  }, ignoreFixedLeft && fixedLeft, nonFixed, ignoreFixedRight && fixedRight), fixedRight && !ignoreFixedRight && React.createElement(TableFixedColumn, {
    height: height,
    position: "right",
    cover: rightCover,
    width: fixedRightWidth
  }, fixedRight));
}